import { Injectable } from '@angular/core';
import { UrlSegments } from '../../jurisdiction/jurisdiction.constants';
import { CommunicationService } from '../../services/communication.service';
import { Observable, Subject } from 'rxjs';
import { GridCompOrderProcess } from '../entities/gridCompOrderProcess';
import { GridCompResultData } from '../entities/gridCompResultData';
import { filter, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GridCompatibilityOrderProcessService {
  private orderProcessSubject = new Subject<GridCompOrderProcess>();

  constructor(private communicationService: CommunicationService) {}

  public orderProcess$ = this.orderProcessSubject.asObservable();

  public loadOrderProcess(applicationId: number) {
    this.communicationService
      .getData<GridCompOrderProcess>(`${UrlSegments.GridCompOrderProcessByApplication}${applicationId}`)
      .pipe(filter(orderProcess => !!orderProcess))
      .subscribe(orderProcess => {
        if (orderProcess.result) {
          orderProcess.result.feedInPermissionValidDate = new Date(orderProcess.result.feedInPermissionValidDate);
        }

        return this.orderProcessSubject.next(orderProcess);
      });
  }

  public issuePermission(orderProcessId: number, result: GridCompResultData): Observable<any> {
    return this.communicationService.postData(UrlSegments.IssuePermission.replace(':id', orderProcessId.toString()), result);
  }

  public resolveIssue(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.OpenIssue.replace(':id', orderProcessId.toString()), {});
  }

  public denyRequest(orderProcessId: number): Observable<GridCompOrderProcess> {
    return this.communicationService.postData(UrlSegments.DenyRequest.replace(':id', orderProcessId.toString()), {});
  }

  public withdrawRequest(orderProcessId: number): Observable<GridCompOrderProcess> {
    return this.communicationService.postData(UrlSegments.WithdrawRequest.replace(':id', orderProcessId.toString()), {});
  }

  public withdrawAndCopyRequest(
    orderProcessId: number,
    applicationId: number,
    sk_status: string,
    sk_type: string
  ): Observable<GridCompOrderProcess> {
    return this.communicationService.postData(
      UrlSegments.WithdrawAndCopyRequest.replace(':id', orderProcessId.toString())
        .replace(':applicationId', applicationId.toString())
        .replace(':sk_status', sk_status)
        .replace(':sk_type', sk_type),
      {}
    );
  }

  public updateRequest(orderProcessId: number): Observable<GridCompOrderProcess> {
    return this.communicationService.postData(UrlSegments.UpdateRequest.replace(':id', orderProcessId.toString()), {});
  }

  public requestExtension(orderProcessId: number): Observable<GridCompOrderProcess> {
    return this.communicationService.postData(UrlSegments.RequestExtension.replace(':id', orderProcessId.toString()), {});
  }

  public saveResultData(result: GridCompResultData): Observable<any> {
    return this.orderProcess$.pipe(
      take(1),
      switchMap(orderProcess =>
        this.communicationService.postData(UrlSegments.SaveResultData.replace(':id', orderProcess.id.toString()), result)
      )
    );
  }
}
